
const menuConfig = [
  {
    key: "dashboard",
    icon: "DashboardOutlined",
    label: "Dashboard",
    children: [
      { key: "dashboard", icon: "DashboardOutlined", label: "Dashboard" },
    ],
  },
  {
    key: "financial",
    icon: "PieChartOutlined",
    label: "Finans Yönetimi",
    children: [
      {
        key: "finance-definitions",
        icon: "DatabaseOutlined",
        label: "Finans Tanımları",
        children: [
          { key: "sector", icon: "PartitionOutlined", label: "Sektörler" },
          { key: "subsector", icon: "SisternodeOutlined", label: "Alt Sektörler" },
          { key: "currency", icon: "DollarOutlined", label: "Para Birimleri" },
          { key: "exchange-rate", icon: "SwapOutlined", label: "Döviz Kurları" },
          //{ key: "customer-group", icon: "TeamOutlined", label: "Cari Grubu" },
          { key: "customer", icon: "ShopOutlined", label: "Cari" },
          { key: "expense", icon: "MoneyCollectOutlined", label: "Giderler" },
          { key: "bank-management", icon: "BankOutlined", label: "Banka Yonetimi" },
          { key: "cashbox", icon: "WalletOutlined", label: "Kasa Kartlari" }
        ]
      },
      {
        key: "finance-transactions",
        icon: "TransactionOutlined",
        label: "Finans Hareketleri",
        children: [
          {
            key: "bank-transactions",
            icon: "BankOutlined",
            label: "Banka Hareketleri",
          },
          {
            key: "customer-transactions",
            icon: "TeamOutlined",
            label: "Cari Hareketleri",
          },
          {
            key: "cashbox-transactions",
            icon: "WalletOutlined",
            label: "Kasa Hareketleri",
          },
          // {
          //   key: "opening-closing-transactions",
          //   icon: "ScheduleOutlined",
          //   label: "Borç-Alacak İşlemleri",
          //   children: [
          //     { key: "bank-opening", icon: "PlusCircleOutlined", label: "Banka Borç" },
          //     { key: "bank-closing", icon: "MinusCircleOutlined", label: "Banka Alacak" },
          //     { key: "cashbox-opening", icon: "PlusCircleOutlined", label: "Kasa Borç" },
          //     { key: "cashbox-closing", icon: "MinusCircleOutlined", label: "Kasa Alacak" },
          //     { key: "customer-opening", icon: "PlusCircleOutlined", label: "Cari Borç" },
          //     { key: "customer-closing", icon: "MinusCircleOutlined", label: "Cari Alacak" }
          //   ]
          // },
          {
            key: "sales-purchase-transactions", icon: "ShoppingCartOutlined", label: "Satış-Satın Alma İşlemleri", children: [
              { key: "purchase-invoice", icon: "ShoppingOutlined", label: "Cari Alış Fişi" },
              { key: "purchase-return-invoice", icon: "RollbackOutlined", label: "Cari Alış İade Fişi" },
              { key: "sale-invoice", icon: "ForwardOutlined", label: "Cari Satış Fişi" },
              { key: "sale-return-invoice", icon: "BackwardOutlined", label: "Cari Satış İade Fişi" },
              { key: "invoice", icon: "FileTextOutlined", label: "Satış Fişi / Alış Fişi" },
            ]
          },
          // {
          //   key: "money-movement-transactions", icon: "SwapOutlined", label: "Hareketler", children: [
          //     { key: "bank-to-bank", icon: "BankOutlined", label: "Banka Virman" },
          //     { key: "customer-to-customer", icon: "TeamOutlined", label: "Cari Virman" },
          //     { key: "cash-to-cash", icon: "WalletOutlined", label: "Kasa Virman" },
          //     { key: "bank-to-customer", icon: "CreditCardOutlined", label: "Giden Havale-EFT" },
          //     { key: "customer-to-bank", icon: "IdcardOutlined", label: "Gelen Havale-EFT" },
          //     { key: "customer-to-cash", icon: "MoneyCollectOutlined", label: "Nakit Tahsilat" },
          //     { key: "cash-to-customer", icon: "MoneyCollectOutlined", label: "Nakit Ödeme" },
          //     { key: "bank-to-cash", icon: "IdcardOutlined", label: "Bankadan Çekilen" },
          //     { key: "cash-to-bank", icon: "CreditCardOutlined", label: "Bankaya Yatan" },
          //   ]
          // }
        ]
      }
    ]
  },

  {
    key: "stock",
    icon: "AppstoreOutlined",
    label: "Stok Yönetimi",
    children: [
      {
        key: "stock-definitions",
        icon: "DatabaseOutlined",
        label: "Stok Tanımları",
        children: [
          { key: "item", icon: "InfoCircleOutlined", label: "Stok Bilgileri" },
          //{ key: "stockgroups", icon: "GroupOutlined", label: "Stok Grupları" },
          //{ key: "substockgroups", icon: "UngroupOutlined", label: "Alt Stok Grupları" },
          { key: "stockcategories", icon: "TagsOutlined", label: "Stok Kategorileri" },
          { key: "prescription", icon: "MedicineBoxOutlined", label: "Müşteri Satışı" },
          { key: "quick-sale", icon: "ShoppingOutlined", label: "Hızlı Satış" },
          { key: "price-list", icon: "AccountBookOutlined", label: "Fiyat Listesi" },
          // { key: "stockcount", icon: "FolderOpenOutlined", label: "Sayım" },
          // { key: "stockpurchase", icon: "FolderOpenOutlined", label: "Satın Alma" },
          // { key: "stocksales", icon: "FolderOpenOutlined", label: "Satış" },

          // { key: "substockcategories", icon: "TagOutlined", label: "Alt Stok Kategorileri" },
          // { key: "stockclass", icon: "ApartmentOutlined", label: "Stok Sınıfları" },
          // { key: "origins", icon: "GlobalOutlined", label: "Menşei" },
          { key: "warehouse", icon: "ShopOutlined", label: "Depo" },
          { key: "producer", icon: "TrademarkCircleOutlined", label: "Marka" },
          //{ key: "model", icon: "AppstoreAddOutlined", label: "Model" },
        ]
      },
      {
        key: "stock-transactions",
        icon: "BoxPlotOutlined",
        label: "Stok Hareketleri",
        children: [
          { key: "count", icon: "RetweetOutlined", label: "Devir" },
          { key: "countdiff", icon: "VerticalAlignMiddleOutlined", label: "Sayım Eksiği/Fazlası" },
          { key: "purchase", icon: "ShoppingOutlined", label: "Alım İrsaliyesi" },
          { key: "purchasereturn", icon: "RollbackOutlined", label: "Alım İade" },
          { key: "sales", icon: "ForwardOutlined", label: "Satış Hareketleri" },
          { key: "salesreturn", icon: "BackwardOutlined", label: "Satış İade" },
          { key: "transfer", icon: "SwapOutlined", label: "Transfer" },
          { key: "serialcode", icon: "FolderOpenOutlined", label: "Karekod Hareketleri" },
          { key: "serialcodes", icon: "FolderOpenOutlined", label: "Karekod" }
        ]
      }
    ]
  },
  {
    key: "ordertransaction",
    icon: "ShoppingCartOutlined",
    label: "Sipariş İşlemleri",
    children: [
      { key: "purchaseorder", icon: "ShoppingOutlined", label: "Satın Alma Siparişi" },
      { key: "salesorder", icon: "ForwardOutlined", label: "Satış Siparişi" },
    ],
  },
  {
    key: "uts",
    icon: "GlobalOutlined",
    label: "Ürün Takip Sistemi(ÜTS)",
    children: [
      { key: "uts-taking", icon: "OrderedListOutlined", label: "ÜTS Alma Bildirimleri" },
      { key: "uts-giving", icon: "OrderedListOutlined", label: "ÜTS Verme/İptal Bildirimleri" },
      { key: "uts-stock-list", icon: "OrderedListOutlined", label: "ÜTS Stok Listesi" },
      { key: "uts-archive", icon: "FolderOpenOutlined", label: "ÜTS Bildirim Arşivi" },

    ],
  },

  // {
  //   key: "salesandmarketing",
  //   icon: "PieChartOutlined",
  //   label: "Satış & Pazarlama",
  //   children: [
  //     { key: "competitor", icon: "ClusterOutlined", label: "Rakipler" },
  //     { key: "metric", icon: "ClusterOutlined", label: "Metrikler" },
  //   ],
  // },
  {
    key: "users",
    icon: "UserOutlined",
    label: "Kullanıcılar",
    children: [
      { key: "employee", icon: "UserSwitchOutlined", label: "Personel" },
      { key: "title", icon: "ProjectOutlined", label: "Ünvanlar" },
      { key: "roles", icon: "CrownOutlined", label: "Roller" },
      { key: "department", icon: "ApartmentOutlined", label: "Departmanlar" },
      { key: "branch", icon: "BranchesOutlined", label: "Şubeler" },
    ],
  },
  {
    key: "commission",
    icon: "DollarCircleOutlined",
    label: "Prim Yönetimi",
    children: [
      { key: "commission-rules", icon: "ControlOutlined", label: "Prim Kuralları" },
      { key: "sales-targets", icon: "TrophyOutlined", label: "Satış Hedefleri" },
      { key: "commissions", icon: "DollarOutlined", label: "Primler" },
      { key: "commission-payments", icon: "PayCircleOutlined", label: "Prim Ödemeleri" },
      { key: "commission-reports", icon: "BarChartOutlined", label: "Prim Raporları" },
    ],
  },
  {
    key: "reports",
    icon: "BarChartOutlined",
    label: "Raporlar",
    children: [
      {
        key: "sales-reports",
        icon: "LineChartOutlined",
        label: "Satış Raporları",
        children: [
          { key: "daily-sales-report", icon: "DollarOutlined", label: "Günlük Satış Raporu" },
          { key: "monthly-sales-report", icon: "CalendarOutlined", label: "Aylık Satış Raporu" },
          { key: "customer-sales-detail-report", icon: "UserOutlined", label: "Müşteri Satış Detay Raporu" },
          { key: "category-sales-analysis-report", icon: "PieChartOutlined", label: "Kategori Bazlı Satış Analizi" },
          { key: "employee-performance-report", icon: "TeamOutlined", label: "Personel Performans Raporu" },
        ],
      },
      {
        key: "stock-reports",
        icon: "BoxPlotOutlined",
        label: "Stok Raporları",
        children: [
          { key: "current-stock-status-report", icon: "DatabaseOutlined", label: "Mevcut Stok Durum Raporu" },
          { key: "stock-movement-report", icon: "SwapOutlined", label: "Stok Hareket Raporu" },
        ],
      },
      {
        key: "financial-reports",
        icon: "DollarCircleOutlined",
        label: "Finans Raporları",
        children: [
          { key: "cash-movement-report", icon: "WalletOutlined", label: "Kasa Hareket Raporu" },
          { key: "bank-movement-report", icon: "BankOutlined", label: "Banka Hareket Raporu" },
        ],
      },
    ],
  },
  {
    key: "settings",
    icon: "SettingOutlined",
    label: "Ayarlar",
    children: [
      { key: "company-profile", icon: "PieChartOutlined", label: "Şirket Profili" },
      { key: "item-type-settings", icon: "ControlOutlined", label: "Ana Grup Tanımları" },
      { key: "country", icon: "FlagOutlined", label: "Ülkeler" },
      { key: "city", icon: "HomeOutlined", label: "Şehirler" },
      { key: "unit", icon: "DeploymentUnitOutlined", label: "Birimler" },
      { key: "unit-group", icon: "GroupOutlined", label: "Birim Grupları" },
      { key: "hospital", icon: "InsertRowLeftOutlined", label: "Hastaneler" },
      { key: "doctor", icon: "InsertRowAboveOutlined", label: "Doktorlar" },
      { key: "numerate-templates", icon: "NumberOutlined", label: "Numara Şablonları" },
    ],
  },
];

export default menuConfig;
